<template>
	<div class="message-bubble products">
		<div class="products-title" v-for="(msg, key) in products" :key="key">
			<div>
				{{ msg.text }}
			</div>
		</div>
		<v-list dense light>
			<v-list-item-group color="primary">
				<v-list-item
					v-for="(item, key) in products[0].additionalParameters"
					:key="key"
				>
					<v-list-item-content @click="getProduct(item.id)">
						<v-btn class="button-rounding">
							{{ item.name }} - ${{ item.price }}
						</v-btn>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>
		</v-list>

		<BackBtn :return_to="'catalogue'" />
	</div>
</template>

<script>
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	data() {
		return {
			carouselItemHeight: 405,
		};
	},
	computed: {
		products: {
			get() {
				let result = this.$store.getters["chatStore/get_products"].messages[0]
					.additionalParameters;
				result.sort((a, b) => a - b);
				return [
					{
						text: this.$store.getters["chatStore/get_products"].messages[0].text,
						additionalParameters: result,
					},
				];
			},
		},
	},
	methods: {
		getProduct(value) {
			let form = new FormData();
			form.append("message", `product:${value}`);
			form.append("driver", "web");

			const data = {
				id: this.$route.params.id,
				data: form,
			};
			this.$store.dispatch("chatStore/get_product_details", data);
		},
	},
};
</script>

<style lang="scss">
.item-description {
	white-space: pre-line;
}
.carousel .v-carousel__controls {
	position: relative !important;
	margin-top: 25px;
}
@media (min-width: 400px) {
	.carousel .v-carousel__controls {
		position: relative !important;
		margin-top: 5px;
	}
}
.products-item {
	position: relative;
	cursor: pointer;
	.image-container {
		display: flex;
		justify-content: center;
		border-radius: 12px 12px 0px 0px;
	}
	img {
		max-width: 100%;
		max-height: 248px;
		width: auto;
		border-radius: 12px 12px 0px 0px !important;
		max-width: 100%;
		margin: 0 auto;
	}
	.v-list {
		width: 100%;
		bottom: 50px;
	}
}
.v-list-item__title:hover {
	overflow: visible;
	text-overflow: unset;
	white-space: wrap;
}
.products .v-list {
	border-radius: 15px !important;
	background: var(--chat-bubble-color) !important;
	button {
		width: 100%;
		color: var(--app-button-text) !important;
		background-color: var(--app-button) !important;
	}
}
</style>
